import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { DataShareService } from "src/app/core/services/datashare.sevice";
import { StorageService } from "src/app/core/services/storage.service";
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { environment } from "src/environments/environment";
import { ToastService } from "src/app/core/services/toast.service";
import { filter } from "rxjs/operators";

@Component({
  selector: 'BTA-home-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})

export class HomeHeaderComponent {
  public logoUrl = environment?.logoUrl;
  public imageUrl = environment?.imageUrl;
  public logoHeight = environment?.logoHeight;
  public logoFailed = false;
  clientAbbr = environment.clientAbbr;
  @Output() loginFlag = new EventEmitter();
  @ViewChild('dropDown') dropDown!: ElementRef;
  countries = [];
  isDropdownOpen = false;
  selectedCountry = {
    "name": '',
    "country_code": '',
    "currency_symbol": '',
    "id": '',
    "flag": ""
  }
  public is_login = false;
  public profileIcon: boolean = false;
  showLanguageDropdown = false;

  // imageUrl + logoUrl is the CDN copy; when it 404s (or the CDN is down) fall
  // back to logoUrl on its own. Guarded so a failing fallback can't re-enter.
  onLogoError() {
    if (!this.logoFailed) this.logoFailed = true;
  }

  constructor(private renderer: Renderer2, private storageService: StorageService, private commonService: CommonService, private sharedService: DataShareService, private toastrService: ToastService, private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showLanguageDropdown = event.url.includes('tutorial');
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlSegments = event.urlAfterRedirects.split('/');
        const langCode = urlSegments[urlSegments.length - 1];

        // Find matching language from the list
        const matchedLang = this.languageList.find(
          lang => lang.code.toLowerCase() === langCode.toLowerCase()
        );

        if (matchedLang) {
          this.selectedLanguage = matchedLang;
        }
      });
  }

  ngOnInit() {
    this.sharedService.counrtyCodeSubject$.subscribe((response: []) => {
      response.forEach((element: any) => {
        const myJson = {
          "name": element.country_name,
          "country_code": element.country_code,
          "currency_symbol": element.currency_symbol,
          "id": element.id,
          "customerNo": element.customercare_no_Flight,
          "calling_code": element.calling_code,
          "flag": this.imageUrl + "assets/images/flags/" + element.country_code + '.svg'
        }
        this.countries.push(myJson);
      });

    })
    this.getInitailSetUp();
  }

  languageList = [
    { code: 'english', label: 'ENGLISH' },
    { code: 'hindi', label: 'HINDI' },
    { code: 'bengali', label: 'BENGALI' }
  ];

  selectedLanguage = this.languageList[0]; // Default to English

  changeLanguage(lang: any) {
    this.selectedLanguage = lang;

    // Get current path segments
    const segments = this.router.url.split('/');

    // Replace the last segment (language code) with the new one
    if (segments.length > 0) {
      segments[segments.length - 1] = lang.code;
      const newUrl = segments.join('/');

      // Navigate to the new URL
      this.router.navigateByUrl(newUrl);
    }
  }

  getInitailSetUp() {
    this.commonService.getInit().subscribe((response: Response) => {
      let selectedCountry = JSON.parse(JSON.stringify(response))
      this.selectedCountry = {
        "name": selectedCountry.country_name,
        "country_code": selectedCountry.country_code,
        "currency_symbol": selectedCountry.currency_symbol,
        "id": selectedCountry.country_id,
        "flag": this.imageUrl + "assets/images/flags/" + selectedCountry.country_code + '.svg'
      }
      if (this.countries.length && this.selectedCountry) this.is_login = true;
      this.storageService.setLocalStorageItem('selected_country', this.selectedCountry)
    })
  }

  toggleCountryDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.renderer.removeStyle(this.dropDown.nativeElement, 'display',)
    } else {
      this.renderer.setStyle(this.dropDown.nativeElement, 'display', 'none')
    }
  }
  selectCountry(country: any) {
    this.storageService.setLocalStorageItem('selected_country', country)
    this.selectedCountry = country;
  }
  navigateToLogin() {
    if (this.countries.length)
      this.loginFlag.emit(true)
  }
}